import { BiImport } from "react-icons/bi";
import { FaInfoCircle } from "react-icons/fa";

export default function ZeroTrustSidebar(props: any) {


    return (
        <div className="navbar-dark bg-dark sidebar-item">
            <div onClick={() => window.open('https://github.com/tatedean/zero-trust', '_blank')} className='sidebar-option flex d-flex flex-row align-items-center p-1 justify-content-between m-0'>
                <FaInfoCircle className='sidebar-icons info' />
            </div>
            <hr style={{ marginBottom: '0' }} />
            <div className='sidebar-option flex d-flex flex-row align-items-center p-1 justify-content-between'>
                <BiImport className={'sidebar-icons '}
                    onClick={() => props.dispatch({ type: 'update', field: 'showImport', payload: true })} />
            </div>
        </div>
    )
}